define(['angular', '../../filters/text'], function (angular) {
    return angular
        .module('campaignModels', ['textFilters'])
        .factory('CampaignModel', [
            '$filter',
            function ($filter) {
                var CampaignModel = function (campaign) {
                    if (typeof campaign == 'undefined' || !campaign) {
                        campaign = {};
                    }

                    if (!campaign.id) {
                        // Default settings for new campaigns
                        campaign.active = true;
                        campaign.campaign_type = 'email';
                        campaign.canDelete = true;
                        campaign.trigger = 'registration';
                    }

                    campaign.delete = function (callback) {
                        var thisCampaign = this;

                        if (thisCampaign.id) {
                            var request = thisCampaign.$delete();
                            if (typeof callback == 'function') {
                                request.then(callback);
                            }
                        } else {
                            if (typeof callback == 'function') {
                                callback();
                            }
                        }
                    };

                    campaign.save = function (callback) {
                        var thisCampaign = this;

                        var request;
                        if (thisCampaign.id) {
                            request = thisCampaign.$update();
                        } else {
                            request = thisCampaign.$save();
                        }
                        request.then(function (data) {
                            thisCampaign.updateData(data);
                            if (typeof callback == 'function') {
                                callback();
                            }
                        });
                        return request;
                    };

                    campaign.updateData = function (data) {
                        var thisCampaign = this;

                        if (data) {
                            for (var key in data) {
                                this[key] = data[key];
                            }
                        } else if (thisCampaign.id) {
                            var newData = thisCampaign.$get();
                            newData.then(function (data) {
                                thisCampaign.updateData(data);
                            });
                        }
                    };
                    campaign.updateData(campaign);

                    return campaign;
                };
                return CampaignModel;
            },
        ]);
});
